import { Component, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ComponentDataDestService } from '../../../services/component-data-dest/component-data-dest.service';

@Component({
  selector: 'app-duna-contact',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatCardModule,
    MatIconModule,
  ],
  templateUrl: './duna-contact.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './duna-contact.component.scss',
})
export class DunaContactComponent {
  name: string = '';
  email: string = '';
  message: string = '';
  subject: string = '';
  isSubmitting: boolean = false;
  isSubmitted: boolean = false;

  constructor(
    private componentDataDestService: ComponentDataDestService,
    private snackBar: MatSnackBar
  ) {}

  onSubmit() {
    // Prevent double submission
    if (this.isSubmitting) {
      return;
    }

    if (!this.name.trim() || !this.email.trim() || !this.message.trim()) {
      this.snackBar.open('Udfyld venligst alle påkrævede felter', 'Luk', {
        duration: 3000,
        panelClass: ['error-snackbar'],
      });
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.email)) {
      this.snackBar.open('Indtast venligst en gyldig email adresse', 'Luk', {
        duration: 3000,
        panelClass: ['error-snackbar'],
      });
      return;
    }

    this.isSubmitting = true;

    const contactData = {
      name: this.name,
      email: this.email,
      message: this.message,
      subject: this.subject || 'General Inquiry',
    };

    try {
      const logContactForm =
        this.componentDataDestService.getDataDest('log_contact_form');
      if (logContactForm) {
        const request$ = logContactForm(contactData);

        request$.subscribe({
          next: (response: any) => {
            this.isSubmitting = false;
            this.isSubmitted = true;
            this.snackBar.open(
              'Din besked er sendt! Vi vender tilbage til dig snarest.',
              'Luk',
              {
                duration: 5000,
                panelClass: ['success-snackbar'],
              }
            );
            this.resetForm();
          },
          error: (error: any) => {
            this.isSubmitting = false;
            console.error('Error submitting contact form:', error);
            this.snackBar.open(
              'Kunne ikke sende besked. Prøv venligst igen.',
              'Luk',
              {
                duration: 5000,
                panelClass: ['error-snackbar'],
              }
            );
          },
        });
      } else {
        throw new Error('Contact form logging service not available');
      }
    } catch (error) {
      this.isSubmitting = false;
      console.error('Error in onSubmit:', error);
      this.snackBar.open('Der opstod en fejl. Prøv venligst igen.', 'Luk', {
        duration: 5000,
        panelClass: ['error-snackbar'],
      });
    }
  }

  private resetForm() {
    this.name = '';
    this.email = '';
    this.message = '';
    this.subject = '';
  }
}
